
<div class="pgWrapper scrollable-container" *ngIf="watchersExceededLimit">
  	<app-watchers-exceeded-limit></app-watchers-exceeded-limit>
</div>

<div class="pgWrapper scrollable-container" *ngIf="!watchersExceededLimit" [class.channelEmbeded]="isEmbedChannel === true" [class.unaccess]="accessOk === false">

 
<channels-header class="hdr" *ngIf="accessOk === true && isEmbedChannel === false" [opacity]="true" ></channels-header>

<div *ngIf="stream?.channel?.url  && (stream?.publish === true || isEmbedChannel === true)" class="subHeader">
	<div class="container">
		<div>	
			<a class="backLink" href="javascript:;" (click)="goBack()">
				<div>
					<nb-icon pack="eva" icon="arrow-back-outline"></nb-icon><span>Повернутися до каналу</span>

					<div class="avatar" [style.background]="stream.channel.avatar_image ? 'url('+stream.channel.avatar_image+')' : ''" ></div>
				</div>
			</a>
		</div> 
	</div>
</div>
	


	<div style="position: relative;" class="container">
			 
		<div *ngIf="!initialLoading; else loading">
	 
				<div class="content">

						   <div *ngIf="accessOk === true">
							<div class="video">
							<app-watch (onTokenClose)="closeByToken()" (onExceededLimit)="onWatchersExceededLimit()"    [stream]="stream" ></app-watch>  
							</div>

							  <div   class="right-wrapper ">
								  <div  *ngIf=" stream.chatEnabled"  class="chat">
								<app-watcher-chat [stream]="stream"></app-watcher-chat>
								</div>


								  <div  *ngIf="!stream.chatEnabled "  class="right-description">
								 	<h5>{{stream.title}}</h5>
								 	<p [innerHTML]="getDescription()"></p>
								  </div>

							 </div>

						 
						 </div>
				</div>

		  
		 
			 
	</div>


 </div>

	
	<div style="position: relative;"  *ngIf="accessOk === true" class="container">  
			<div class="bottom-description">
				 <div  *ngIf="stream.chatEnabled "  class="description">
						<h5>{{stream.title}}</h5>
					 <p [innerHTML]="getDescription()"></p>
				 </div>


				<div *ngIf="stream?.publish === true" class="socials">
<div class="socialNetworks">

		<a target="_blank" *ngIf="stream?.channel?.site" href="{{stream?.channel?.site}}" class="socNetItem">
					<div class="icon site"></div> <div class="text">WWW</div>
				</a>

				 <a target="_blank" *ngIf="stream?.channel?.soc_facebook" href="{{stream?.channel?.soc_facebook}}" class="socNetItem">
					<div class="icon facebook"></div> <div class="text">Facebook</div>
				</a>

				 <a target="_blank" *ngIf="stream?.channel?.soc_twitter" href="{{stream?.channel?.soc_twitter}}"  class="socNetItem">
					<div class="icon twitter"></div> <div class="text">Twitter</div>
				</a>

				 <a  target="_blank" *ngIf="stream?.channel?.msg_whatsapp" href="{{stream?.channel?.msg_whatsapp}}" class="socNetItem">
					<div class="icon whatsapp"></div> <div class="text">Whatsapp</div>
				</a>

				 <a   target="_blank" *ngIf="stream?.channel?.msg_telegram" href="{{stream?.channel?.msg_telegram}}" class="socNetItem">
					<div class="icon telegram"></div> <div class="text">Telegram</div>
				</a>

				
				 <a  target="_blank" *ngIf="stream?.channel?.soc_instagram" href="{{stream?.channel?.soc_instagram}}" class="socNetItem">
					<div class="icon instagram"></div> <div class="text">Instagram</div>
				</a>

				 <a  target="_blank" *ngIf="stream?.channel?.msg_viber" href="{{stream?.channel?.msg_viber}}" class="socNetItem">
					<div class="icon viber"></div> <div class="text">Viber</div>
				</a>

				 <a  target="_blank" *ngIf="stream?.channel?.soc_vk" href="{{stream?.channel?.soc_vk}}" class="socNetItem">
					<div class="icon vk"></div> <div class="text">Вконтакте</div>
				</a>

				</div>
				</div>

			</div>
	   </div>

 

<app-access  (onAuth)="onAuth($event)" [sessionKey]="sessionKey"  [stream]="stream" *ngIf="accessOk === false"></app-access>

<ng-template #loading>
    <div style="position: absolute; z-index: 777; width:100%; height:100%; top:0; left: 0; display: flex; align-self: center;">
        <div style="margin: auto;">  <app-loader></app-loader> </div>
        </div>
</ng-template>
		

		   <ng-template #loader>
        <div class="row">
		<div class="col">
		<div style="display:flex;  width:100%; height:300px; "> 
			<div style="display:flex;margin: auto;"> <app-loader></app-loader></div>
		    
		 </div>
		 </div>
        </div>
    </ng-template> 
<div>

